import { Col, Row } from 'react-bootstrap';
import { InternalButtonBar } from '../../../../../layout/components';
import React, { useState } from 'react';
import CancelButton from '../../../CancelButton/CancelButton';
import { Button } from '../../../../../../common/components';
import TransferPolicyButton from '../../../TransferPolicyButton/TransferPolicyButton';
import ExpiredMidTermAdjustmentButton from '../../../ExpiredMidTermAdjustmentButton/ExpiredMidTermAdjustmentButton';
import SendSmsButton from '../../../SendSmsButton/SendSmsButton';
import { get } from 'lodash';
import LapseButton from '../../../LapseButton/LapseButton';
import PreventRenewalButton from '../../../PreventRenewalButton/PreventRenewalButton';
import UpdateSourceButton from '../../../UpdateSourceButton/UpdateSourceButton';

const hasStatus = (statuses, status) => {
  if (!statuses) {
    return true;
  }

  return statuses.indexOf(status) !== -1;
};

const filterButtons = (actionButtons, resource, broker) => {
  const resourceAttributes = resource.data.attributes;
  const type = resourceAttributes.policy_number ? 'policy' : 'application';
  const productName = resourceAttributes.product_name;
  const filteredProducts = {
    names: [
      'Hospital Cash Plan',
      'Cancer Care',
      'Personal Accident',
      'Surgery Cash Plan',
    ],
    buttonTypes: ['transfer-button'],
  };

  return actionButtons.filter((button) => {
    if (button.type !== type) {
      return false;
    }
    if (
      filteredProducts.names.includes(productName) &&
      filteredProducts.buttonTypes.includes(button.button.key)
    ) {
      return false;
    }
    if ('Smart Luggage' === productName && 'send-sms-button' === button.button.key) {
      return false;
    }

    let render = true;
    if (button.conditions) {
      button.conditions.forEach((condition) => {
        switch (condition) {
          case 'isInsideCancellationPeriod':
            if (!resourceAttributes.is_inside_cancellation_period) {
              render = false;
            }
            break;

          case 'isOutsideCancellationPeriod':
            if (resourceAttributes.is_inside_cancellation_period) {
              render = false;
            }
            break;

          case 'hasMta':
            if (resourceAttributes.version === 1) {
              render = false;
            }
            break;

          case 'checkMtaPermission':
            if (
              (type === 'policy' && resourceAttributes.version > 1) ||
              resourceAttributes.quote_type === 'mid term adjustment'
            ) {
              button['permissions'].push('policy.mta');
            }
            break;

          case 'isAnnual':
            render = resourceAttributes.metadata.scheme_type === 'annual';
            break;
          case 'hasBroker':
            render = !!broker.data.attributes;
            break;
        }
      });
    }

    return render ? hasStatus(button.statuses, resourceAttributes.status) : false;
  });
};

const Buttons = ({
  resource,
  user,
  broker,
  product,
  customer,
  handleUncancel,
  handleEditQuote,
  handleEndorsementEmail,
  handleCustomerLogin,
}) => {
  const [disableEditQuote, setDisableEditQuote] = useState(false);
  const onEditQuote = () => {
    setDisableEditQuote(true);
    handleEditQuote(product);
  };

  const isSmartLuggage = resource.data.attributes.product_name === 'Smart Luggage';
  const hasDocs = !!resource.data.relationships?.documents?.data?.length;

  const actionButtons = [
    {
      type: 'policy',
      statuses: ['expired'],
      permissions: ['policy.underwriter'],
      button: (
        <CancelButton key="cancel-button" className="pull-right" resource={resource} />
      ),
    },
    {
      type: 'policy',
      statuses: ['issued', 'on cover', 'active'],
      permissions: ['policy.cancel'],
      conditions: ['isInsideCancellationPeriod'],
      button: (
        <CancelButton className="pull-right" key="cancel-button" resource={resource} />
      ),
    },
    {
      type: 'policy',
      statuses: ['issued', 'on cover', 'active'],
      permissions: ['policy.underwriter'],
      conditions: ['isOutsideCancellationPeriod'],
      button: (
        <CancelButton className="pull-right" key="cancel-button" resource={resource} />
      ),
    },
    {
      type: 'policy',
      statuses: ['cancelled'],
      permissions: ['policy.uncancel'],
      button: (
        <Button
          label="Un-cancel"
          bsStyle="primary"
          className="pull-right"
          key="uncancel-button"
          handleClick={handleUncancel}
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.transfer_customer'],
      button: (
        <TransferPolicyButton
          className="pull-right"
          key="transfer-button"
          resource={resource}
          user={user}
          resourceType={'policies'}
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.update-source'],
      button: (
        <UpdateSourceButton
          className="pull-right"
          key="update-source"
          policyId={resource.data.id}
          policyNumber={resource?.data?.attributes?.policy_number}
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['customer.view', 'customer.view_owner'],
      button: (
        <Button
          link
          className="pull-right"
          key="customer-button"
          to={'/customers/' + customer.data.id}
          bsStyle="primary"
          label="View Customer"
        />
      ),
    },
    {
      type: 'application',
      permissions: ['customer.view', 'customer.view_owner'],
      button: (
        <Button
          link
          className="pull-right"
          key="customer-button"
          to={'/customers/' + customer.data.id}
          bsStyle="primary"
          label="View Customer"
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.quote'],
      statuses: ['issued', 'on cover', 'active'],
      button: (
        <Button
          label="Mid-term Adjustment"
          link
          to={'/products/' + product.data.id + '/adjustment/' + resource.data.id}
          className="pull-right"
          key="mta-button"
          bsStyle="primary"
          rightIcon="pencil"
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.mta_expired'],
      statuses: ['expired'],
      button: (
        <ExpiredMidTermAdjustmentButton
          productId={product.data.id}
          policyId={resource.data.id}
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.quote'],
      statuses: ['issued', 'on cover', 'active'],
      conditions: ['hasMta'],
      button: (
        <Button
          label="Send Endorsement Email"
          bsStyle="primary"
          className="pull-right"
          key="send-endorsement-button"
          handleClick={handleEndorsementEmail}
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.quote'],
      statuses: ['issued', 'on cover', 'active'],
      button: (
        <SendSmsButton
          className="pull-right"
          key="send-sms-button"
          resource={resource}
          phoneNumber={get(
            customer,
            'data.attributes.phone2',
            get(customer, 'data.attributes.phone1'),
          )}
        />
      ),
    },
    {
      type: 'policy',
      key: 'send-policy-button',
      permissions: ['policy.quote'],
      statuses: ['issued', 'on cover', 'active', 'expired', 'cancelled'],
      button: (
        <Button
          disabled={isSmartLuggage && !hasDocs}
          label="Send Policy Email"
          key="send-policy-button"
          bsStyle="primary"
          className="pull-right"
          handleClick={handleCustomerLogin}
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.quote'],
      statuses: ['quote'],
      conditions: ['checkMtaPermission'],
      button: (
        <Button
          label="Send Quote Email"
          bsStyle="primary"
          className="pull-right"
          key="send-quote-button"
          handleClick={handleCustomerLogin}
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.underwriter'],
      statuses: ['applied', 'quote', 'renewal', 'renewal invited', 'lapsed'],
      conditions: ['hasBroker'],
      button: (
        <TransferPolicyButton
          className="pull-right"
          key="transfer-renewal-button"
          label={'Transfer to new broker'}
          resource={resource}
          user={user}
          resourceType={'policies/applications'}
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.quote'],
      statuses: ['applied', 'quote', 'renewal', 'renewal invited', 'lapsed'],
      conditions: ['checkMtaPermission'],
      button: (
        <Button
          label="Edit"
          className="pull-right"
          key="edit-button"
          bsStyle="primary"
          rightIcon="pencil-square-o"
          disabled={disableEditQuote || !product.data.id}
          handleClick={onEditQuote}
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.handle_all_referrals'],
      statuses: ['referred', 'referral approved'],
      button: (
        <Button
          label="Edit"
          className="pull-right"
          key="edit-button"
          bsStyle="primary"
          rightIcon="pencil-square-o"
          disabled={disableEditQuote || !product.data.id}
          handleClick={onEditQuote}
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.quote'],
      statuses: ['applied', 'quote'],
      button: (
        <Button
          label="Clone"
          link
          to={
            '/products/' + product.data.id + '/quote/' + resource.data.id + '?clone=quote'
          }
          className="pull-right"
          key="clone-button"
          bsStyle="primary"
          rightIcon="pencil-square-o"
        />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.quote'],
      button: (
        <Button
          label="Clone"
          link
          to={
            '/products/' +
            product.data.id +
            '/quote/' +
            resource.data.id +
            '?clone=policy'
          }
          className="pull-right"
          key="clone-button"
          bsStyle="primary"
          rightIcon="clone"
        />
      ),
    },
    {
      type: 'application',
      permissions: ['policy.quote'],
      statuses: [
        'applied',
        'quote',
        'renewal',
        'referred',
        'referral approved',
        'renewal invited',
        'lapsed',
      ],
      button: (
        <LapseButton className="pull-right" key="lapse-button" resource={resource} />
      ),
    },
    {
      type: 'policy',
      permissions: ['policy.quote'],
      statuses: ['issued', 'on cover', 'active'],
      conditions: ['isAnnual'],
      button: (
        <PreventRenewalButton
          className="pull-right"
          resource={resource}
          key="prevent-renewal-button"
        />
      ),
    },
  ];
  const buttons = filterButtons(actionButtons, resource, broker);

  return (
    <Row>
      <Col sm={12}>
        <InternalButtonBar buttons={buttons} />
      </Col>
    </Row>
  );
};
export default Buttons;
